import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { AppConfigurationApiService } from '../../../../DBadgeEmployee-app/src/app/core/services/data-access/app-configuration.api.service';
import * as EmployeeModels from '../../../../DBadgeEmployee-app/src/app/models';
import * as SharedModels from '@ui-app/models';

@Injectable({
    providedIn: 'root',
})
export class AppConfigurationService {
    private featuresConfigurationSubject = new BehaviorSubject<EmployeeModels.DM.IFeaturesConfiguration>(null);

    constructor(private appConfigurationApiService: AppConfigurationApiService) {}

    getConfiguration(): Observable<EmployeeModels.DM.IFeaturesConfiguration> {
        return this.appConfigurationApiService.getConfiguration().pipe(
            tap((response) => this.featuresConfigurationSubject.next(response)),
            catchError((error) => {
                this.featuresConfigurationSubject.next(null);
                return throwError(error);
            })
        );
    }

    isSettingEnabled$(field: SharedModels.CE.AppConfigurationSettings): Observable<boolean> {
        return this.featuresConfigurationSubject.pipe(
            filter((config) => !!config),
            map((configuration) => configuration[field])
        );
    }
}
